var _path, _path2, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_770_60250)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_770_60250)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_770_60250",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 17,
    height: 16
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.980469 0H16.9805V16H0.980469V0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_770_60250)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_770_60250",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 17,
    height: 16
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.980469 0H16.9805V16H0.980469V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_770_60250)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.3096 7.98734C16.3082 8.20322 16.222 8.40991 16.0696 8.56281C15.9172 8.71571 15.7108 8.80258 15.4949 8.80467H14.6802L14.6983 12.8813C14.6979 12.9502 14.6937 13.019 14.6856 13.0873V13.5C14.6857 13.6338 14.6594 13.7663 14.6082 13.8899C14.557 14.0136 14.482 14.1259 14.3874 14.2205C14.2928 14.3151 14.1805 14.3901 14.0568 14.4413C13.9332 14.4925 13.8007 14.5188 13.667 14.5187H13.2596C13.2316 14.5187 13.2036 14.496 13.1756 14.5187C13.1402 14.498 13.1042 14.5187 13.0689 14.5187H11.6296C11.4958 14.5188 11.3633 14.4925 11.2396 14.4413C11.116 14.3901 11.0037 14.3151 10.9091 14.2205C10.8144 14.1259 10.7394 14.0136 10.6883 13.8899C10.6371 13.7663 10.6108 13.6338 10.6109 13.5V11.2593C10.611 11.1523 10.59 11.0464 10.5491 10.9475C10.5082 10.8486 10.4482 10.7588 10.3725 10.6831C10.2969 10.6074 10.207 10.5474 10.1081 10.5065C10.0092 10.4656 9.90327 10.4446 9.79626 10.4447H8.16622C8.05921 10.4446 7.95325 10.4656 7.85437 10.5065C7.75549 10.5474 7.66563 10.6074 7.58996 10.6831C7.5143 10.7588 7.45436 10.8486 7.41345 10.9475C7.37254 11.0464 7.35151 11.1523 7.3516 11.2593V13.5C7.35169 13.6338 7.32537 13.7663 7.27421 13.8899C7.22305 14.0136 7.14803 14.1259 7.05342 14.2205C6.95882 14.3151 6.84649 14.3901 6.72286 14.4413C6.59923 14.4925 6.46668 14.5188 6.33288 14.5187H4.90954C4.87154 14.5187 4.83288 14.5187 4.79488 14.5133C4.75688 14.508 4.73359 14.5187 4.70292 14.5187H4.29561C4.02544 14.5187 3.76635 14.4114 3.57532 14.2203C3.38428 14.0293 3.27689 13.7702 3.27689 13.5V8.80467H2.46358C2.35599 8.80584 2.24923 8.78548 2.14962 8.7448C2.05 8.70412 1.95953 8.64394 1.8835 8.5678C1.80748 8.49165 1.74742 8.40107 1.70691 8.30139C1.66639 8.20171 1.64624 8.09493 1.64758 7.98734C1.64564 7.8734 1.66724 7.76027 1.71106 7.65508C1.75488 7.54988 1.81996 7.45487 1.90222 7.376L8.43095 1.68534C8.50489 1.61394 8.59299 1.55889 8.68957 1.52375C8.78616 1.48861 8.88904 1.47415 8.99158 1.48134C9.18576 1.47827 9.37525 1.54127 9.52893 1.66001L16.0296 7.376C16.1244 7.44565 16.1999 7.53836 16.2489 7.64534C16.2979 7.75232 16.3188 7.87004 16.3096 7.98734Z"
  })))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_770_60250"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0.980469)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_770_60250"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0.980469)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.46119e635717fea3a65e59fdcaa89275.svg";
export { ForwardRef as ReactComponent };